import type { Distance, Rectangle } from "@pdfking/math"
import type { Atom } from "@pdfking/tfunc"

import type { LayoutObject } from "../types/layout"

/** Page `page_number` of `size`, front side up — the smallest thing a fill can
 * tile, and what it tiles when it is given nothing else. */
export const PageObject = <D>(page_number: Atom, size: Rectangle<Distance>): LayoutObject<D> => ({
  is_front: true,
  layout: { enum: "page", is_front: true, page_number, size },
  size,
})
